"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var camelToWordsRegex = /([A-Z])/g;
exports.default = (function (camelCase) {
    return camelCase
        // insert a space before all caps
        .replace(camelToWordsRegex, ' $1')
        // uppercase the first character
        .replace(/^./, function (str) { return str.toUpperCase(); });
});
